import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useDispatch } from '@bridebook/web/lib/utils';
import { toggleSnackbar } from '@bridebook/web/lib/bbcommon/actions';
import { useTranslation } from 'next-i18next';

export const useCaptcha = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getCaptchaToken = async (action: string) => {
    if (!executeRecaptcha) {
      dispatch(toggleSnackbar('alert', t('error.captchaNotEnabled')));
      throw new Error('Captcha not enabled');
    }
    return await executeRecaptcha(action);
  };

  return { getCaptchaToken };
};
